import React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { SavedReportsEndpoints } from 'app/area/shared/saved-reports/constants';
import { SavedReportValidation } from 'app/area/shared/saved-reports/types-store';

import { CompanyReportAdminTranslation } from '../../constants';
import { SavedReportCompanyReport } from '../types-store';
import { SavedReportPicker } from './saved-report-picker';
import { SavedReportCellRange } from './saved-report-cell-range';

interface SavedReportFormProps {
  savedReport: SavedReportCompanyReport;

  updateCurrent: (savedReport: Partial<SavedReportCompanyReport>) => void;

  endpoints: SavedReportsEndpoints;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  locale: string;
  validation: SavedReportValidation<SavedReportCompanyReport>;
  translation: CompanyReportAdminTranslation;
}

const reportId = 'reportId';
const reportName = 'reportName';
const reportResult = 'reportResult';

export const SavedReportForm: React.FC<SavedReportFormProps> = ({
  savedReport, updateCurrent,
  endpoints, options, loadOptions,
  locale, validation, translation
}) => {

  const onReportResultCellChange = (reportResultCell: string) => {
    updateCurrent({ reportResultCell });
  };

  const onReportResultRangeChange = (reportResultRange: string) => {
    updateCurrent({ reportResultRange });
  };

  const onReportIdCellChange = (reportIdCell: string) => {
    updateCurrent({ reportIdCell });
  };

  const onReportIdRangeChange = (reportIdRange: string) => {
    updateCurrent({ reportIdRange });
  };

  const onReportNameCellChange = (reportNameCell: string) => {
    updateCurrent({ reportNameCell });
  };

  const onReportNameRangeChange = (reportNameRange: string) => {
    updateCurrent({ reportNameRange });
  };

  return <>
    {(!savedReport?.code?.description || !!validation?.code) && <SavedReportPicker
      valueItem={savedReport?.code}
      updateCurrent={updateCurrent}
      endpoints={endpoints}
      options={options}
      loadOptions={loadOptions}
      locale={locale}
      validation={validation}
      translation={translation} />}
    <SavedReportCellRange
      id={reportResult}
      title={translation.report_result}
      cellRequired={true}
      cellValue={savedReport.reportResultCell}
      rangeValue={savedReport.reportResultRange}
      onUpdateCell={onReportResultCellChange}
      onUpdateRange={onReportResultRangeChange}
      cellValidation={validation?.reportResultCell}
      rangeValidation={validation?.reportResultRange}
      translation={translation} />
    <SavedReportCellRange
      id={reportId}
      title={translation.report_id}
      cellRequired={false}
      cellValue={savedReport.reportIdCell}
      rangeValue={savedReport.reportIdRange}
      onUpdateCell={onReportIdCellChange}
      onUpdateRange={onReportIdRangeChange}
      cellValidation={validation?.reportIdCell}
      rangeValidation={validation?.reportIdRange}
      translation={translation} />
    <SavedReportCellRange
      id={reportName}
      title={translation.report_name}
      cellRequired={false}
      cellValue={savedReport.reportNameCell}
      rangeValue={savedReport.reportNameRange}
      onUpdateCell={onReportNameCellChange}
      onUpdateRange={onReportNameRangeChange}
      cellValidation={validation?.reportNameCell}
      rangeValidation={validation?.reportNameRange}
      translation={translation} />
  </>;
};
